<img
  *ngIf="!isOnlytext"
  src="/assets/img/help_outline_24px.svg"
  alt="help icon"
  style="margin-bottom: 2px; cursor: pointer"
  matTooltipClass="help-icon-tooltip"
  [matTooltip]="tooltipText"
  matTooltipPosition="above"
  (mouseenter)="onTooltipHover()"
/>

<div *ngIf="isOnlytext" [matTooltip]="tooltipText"  matTooltipPosition="above">
  <span [matTooltip]="tooltipText"  matTooltipPosition="above"></span>
</div>